import React from 'react'
import $ from 'jquery';
import Page from '../Page'
import { API_LOGOUT, ClearUserData , BASE_URL } from '../Util';

class Logout extends Page {
	constructor(props) {
	    super(props);
	    this.state = {data: null};
	}

	componentDidMount() {
	    this.handleLogout();
	}

  	handleLogout = () => {
		$.post(API_LOGOUT)
	      .then((data) => {
	      ClearUserData();
	      this.props.history.push("/", {needRefresh: true});
	    });
	}

  	render() {
  		return super.render();
	}
}
export default Logout



// WEBPACK FOOTER //
// ./src/components/Auth/Logout.js